import React, { useEffect, useState } from 'react'
import { SwitchButtonProps } from './SwitchButton.types'
import styles from './SwitchButton.module.scss'
import cl from 'classnames'
import { Button } from '../Button'

const SwitchButtonComponent = (props: SwitchButtonProps) => {
  const {
    isOn,
    alwaysSync,
    disabled,
    onChange,
    className,
    style
  } = props

  const [switchedOn, setSwitchedOn] = useState(!!isOn)

  useEffect(() => setSwitchedOn(isOn), [isOn])

  const switchOnOff = () => {
    const value = !switchedOn
    !alwaysSync && setSwitchedOn(value)
    onChange && onChange(value)
  }

  // return (
  //   <div
  //     className={cl(styles.container, {
  //       [styles.switchedOn]: switchedOn
  //     })}
  //     onClick={switchOnOff}
  //     // disabled
  //   >
  //     <span className={styles.label}>YES</span>
  //     <div className={cl(styles.circle)} />
  //     <span className={styles.label}>NO</span>
  //   </div>
  // )

  return (
    <Button
      preset='icon'
      className={cl(styles.container, {
        [styles.switchedOn]: switchedOn
      }, className)}
      style={style}
      onClick={switchOnOff}
      disabled={disabled}
    >
      <span className={styles.label}>YES</span>
      <div className={cl(styles.circle)} />
      <span className={styles.label}>NO</span>
    </Button>
  )
}

const SwitchButton = SwitchButtonComponent
export { SwitchButton }
